module.exports = __webpack_public_path__ + "img/icon_sm_fhysd.f5200c5e.png";